import restApi from '@/utils/rest-api'

export default {
    fetchJobPositionByCode(code) {
        return restApi({
            url: `/job-positions/${code}`,
            method: 'get'
        })
    }
}
